module.exports = __webpack_public_path__ + "img/1535983024.8b52ce1c.jpg";